export default () => {
    return {
        isiTitle: "",
        isiCopy: "",
        indicationTitle: "",
        indicationCopy: ""
    };
};
